import axios from "axios";
import TokenMiddleware from "../middleware/token.middleware";
import Constants from '../tools/constants.tools'

export const privateApi = axios.create({
  baseURL: Constants.URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const publicApi = axios.create({
  baseURL: Constants.URL,
  headers: {
    "Content-Type": "application/json",
  },
});


privateApi.interceptors.request.use(
  (config) => {
    if(TokenMiddleware.getToken()){
      // const isToken = TokenMiddleware.verifyToken(TokenMiddleware.getToken());
      // if (isToken) {
      // }
      config.headers["Authorization"] = 'Bearer ' + TokenMiddleware.getToken();
      return config;
    } else {
      return window.location.pathname = "/login"
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

privateApi.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        // refresh token
        try {
          const rs = await privateApi.post("/auth/refresh", {
            refreshToken: TokenMiddleware.getToken(),
          });

          TokenMiddleware.setToken(rs.data.token);

          return privateApi(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);
